import { i18n } from "../i18n";

const SEASON_MESSAGE_KEYS: Record<string, string> = {
  spring: "pages.panoramaGallery.spring.seasonTitle",
  summer: "pages.panoramaGallery.summer.seasonTitle",
  autumn: "pages.panoramaGallery.autumn.seasonTitle",
  winter: "pages.panoramaGallery.winter.seasonTitle",
};

export function getSeasonTitle(season: string): string {
  const key = SEASON_MESSAGE_KEYS[season];
  if (key) {
    return i18n.global.t(key);
  }
  return i18n.global.t("pages.panoramaGallery.title");
}
